/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIMessageRequest
 */
export interface APIMessageRequest {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof APIMessageRequest
     */
    eventData?: { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof APIMessageRequest
     */
    body: string;
}

/**
 * Check if a given object implements the APIMessageRequest interface.
 */
export function instanceOfAPIMessageRequest(value: object): value is APIMessageRequest {
    if (!('body' in value) || value['body'] === undefined) return false;
    return true;
}

export function APIMessageRequestFromJSON(json: any): APIMessageRequest {
    return APIMessageRequestFromJSONTyped(json, false);
}

export function APIMessageRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIMessageRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'eventData': json['event_data'] == null ? undefined : json['event_data'],
        'body': json['body'],
    };
}

export function APIMessageRequestToJSON(value?: APIMessageRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'event_data': value['eventData'],
        'body': value['body'],
    };
}

